import React from 'react';
import clsx from 'clsx';
import { Box, Button } from '@material-ui/core';
import Modal from 'components/Modal';

import classes from './MarkActiveModal.module.scss';

const MarkActiveModal = ({ isActive = true, open = false, handleSubmit, handleClose }) => {
  return (
    <Modal
      modalProps={{
        className: {
          classRoot: clsx(classes.root, classes.markActive, classes.activeModal, {
            [classes.activeModal]: isActive,
            [classes.inactiveModal]: !isActive,
          }),
        },
        open,
        handleClose,
        title: isActive ? 'Mark as inactive?' : 'Mark as active?',
        size: 'small',
        footer: (
          <>
            <Button
              className={isActive ? classes.inActiveButton : classes.activeButton}
              variant='outlined'
              onClick={handleSubmit}>
              {isActive ? 'Mark as inactive' : 'Mark as active'}
            </Button>
            <Button className={classes.button} variant='contained' onClick={handleClose}>
              Back
            </Button>
          </>
        ),
      }}>
      <Box>
        <Box>
          <Box className={classes.markActiveModalText}>
            {isActive
              ? 'An inactive profile will lose all functions including:'
              : 'An active profile will gain all functions including:'}
          </Box>
          <ul>
            <li>Share, upload, download files</li>
            <li>Set expiry date and reminder</li>
            <li>Get DoC</li>
          </ul>
          {isActive ? (
            <Box className={classes.markActiveModalText}>
              Unless you reactivate the profile again.
            </Box>
          ) : null}
        </Box>
      </Box>
    </Modal>
  );
};

export default MarkActiveModal;
